import OpenDebitCardMailing from './OpenDebitCardMailing';

export default OpenDebitCardMailing;
